import { useEffect, useState } from "react";

export interface MaskIMG {
  wContainer: number;
  wImage: number;
  hImage: number;
  wSvg: number;
  hSvg: number;
  dPath: "defaultPath" | "dPath1" | "dPath2" | "dPath3";
  imgURL: string;
  x: number; // sposta immagine all'interno della mask su asse X
  y: number; // sposta immagine all'interno della mask su asse Y
}
type StringMap = Record<string, string>;
const paths: StringMap = {
  defaultPath: "M0,0 H400 V200 Q200,300 0,200 Z",
  dPath1:
    "M256.00066776976206,208.46748056903027L256.00066776976206,98.49848838837072C256.00098718469474,91.63915934722539 253.472980960036,85.02037941357365 248.90004930018944,79.90777821348985L183.39339377461204,6.681481648939177C179.59018195072213,2.4299988821563674 174.15594289167177,-0.00001517828897185121 168.451600169377,0L20.047783795627673,0C8.975698537397612,0 0,8.975698537397609 0,20.04778379562767L0,87.84667032432917L0,216.4146085069346C-0.0000538823504374888,224.20793113947119 2.8726199036003868,231.72780797880117 8.068662034593617,237.53616607990455L72.60682881530863,309.68045304004795C76.41004063919857,313.9319358068307 81.84427969824891,316.3619498672761 87.54862242054367,316.3619346889871L165.58219350193943,316.3619346889871C170.89923491533193,316.36199372393276 175.99852435298476,314.2498486285551 179.75826126430744,310.4901534610111C183.51799817563014,306.73045829346705 185.6301998878155,301.63119230707974 185.63019988748775,296.31415089335945L185.63019988748775,248.56327075020633C185.63019988748775,237.49106255895762 194.6059980817874,228.51526436465795 205.6782062730361,228.51526436465795L235.952438794293,228.51526436465795C241.26951877353366,228.51538243540568 246.36886539583872,226.40326340212212 250.12865044981595,222.64356183584428C253.88843550379315,218.8838602695664 256.000667771073,213.78456054958187 256.00066776976206,208.46748056903027Z",
  dPath2:
    "M92.63120608694639,15.096621340821613L79.16522765847539,48.76169169880646C75.51824025061991,57.87913378285276 66.68796398477888,63.857831312990164 56.86817442099827,63.85831303962808L24.01618835665653,63.85831303962808C10.75251085163968,63.85831303891762 0.0001372824118681678,74.61057531836352 0,87.87425282266992L0,231.98406021695817C0.0001372824118563873,245.24773772126457 10.752510851639672,256.00000000071043 24.016188356656524,256L235.2043313952359,256C248.46800890025278,256.0000000007105 259.2203824694806,245.24773772126457 259.2205197518925,231.98406021695817L259.2205197518925,24.015939783041844C259.22038247119576,10.752359351955779 248.46816039993672,0.00013728069670906033 235.20457996885065,0L114.92925361888229,0C105.1091014489968,0.00007517138601784277 96.27832817091219,5.978842600908808 92.63120608694636,15.09662134082162Z",
  dPath3:
    "M128,0C57.30755202165845,0 0,57.30755202165844 0,128C0,198.69244797834153 57.307552021658424,256 128,256C198.69244797834153,256 256,198.6924479783416 256,128C256,57.30755202165848 198.6924479783416,0 128,0Z",
};
const stroke = 6;
const padding = stroke;

export default function MaskedImage({
  wContainer,
  wImage,
  wSvg,
  hImage,
  hSvg,
  dPath,
  imgURL,
  x,
  y,
}: MaskIMG) {
  const [path, setPath] = useState(paths[0]);

  useEffect(() => {}, []);

  return (
    <div style={{ width: wContainer ?? 400 }}>
      <svg viewBox={`-${padding} -${padding} ${wSvg + padding * 2} ${hSvg + padding * 2}`}>
        <defs>
          <clipPath id="myShape">
            <path d={paths[dPath]} />
          </clipPath>

          {/* Gradiente stile Instagram */}
          <linearGradient
            id="instaGradient"
            x1="0%"
            y1="0%"
            x2="100%"
            y2="100%"
          >
            <stop offset="0%" stopColor="#feda75" />
            <stop offset="25%" stopColor="#fa7e1e" />
            <stop offset="50%" stopColor="#d62976" />
            <stop offset="75%" stopColor="#962fbf" />
            <stop offset="100%" stopColor="#4f5bd5" />
          </linearGradient>
        </defs>

        {/* Immagine clipppata */}
        <image
          href={imgURL}
          width={wImage}
          height={hImage}
          clipPath="url(#myShape)"
          x={x}
          y={y}
        />

        {/* BORDO */}
        <path
          d={paths[dPath]}
          fill="none"
          stroke="url(#instaGradient)"
          strokeWidth="6"
        />
      </svg>
    </div>
  );
}

// Le opzioni principali:
// preserveAspectRatio="xMidYMid slice"
// Valore	        Effetto
// xMidYMid slice	centrata e riempie (tipo cover)
// xMinYMid slice	spostata a sinistra
// xMaxYMid slice	spostata a destra
// xMidYMin slice	spostata in alto
// xMidYMax slice	spostata in basso
